import React, { useMemo } from "react"
import { SelectField } from "@mimber/forms"
import { useMembershipTiers } from "@mimber/client/mimber-organization"
import type { MembershipTierSelectProps } from "./MembershipTierSelect.types"

export const MembershipTierSelect: React.FunctionComponent<
  MembershipTierSelectProps
> = ({
  name,
  label = "Membership Tier",
  placeholder = "Select a tier",
  required = false,
  excludeTierUuid,
  filterFn,
  help,
  disabled = false,
}) => {
  const { data, isLoading, error } = useMembershipTiers()

  const options = useMemo(() => {
    if (!data?.data) return []

    let tiers = data.data

    // Filter out excluded tier
    if (excludeTierUuid) {
      tiers = tiers.filter((tier) => tier.uuid !== excludeTierUuid)
    }

    // Apply custom filter if provided
    if (filterFn) {
      tiers = tiers.filter(filterFn)
    }

    // Transform to select options
    return tiers.map((tier) => ({
      label: tier.name,
      value: tier.uuid,
    }))
  }, [data, excludeTierUuid, filterFn])

  if (error) {
    return (
      <SelectField
        name={name}
        label={label}
        placeholder="Error loading tiers"
        options={[]}
        disabled={true}
        help="Failed to load membership tiers"
      />
    )
  }

  return (
    <SelectField
      name={name}
      label={label}
      placeholder={placeholder}
      required={required}
      options={options}
      loading={isLoading}
      disabled={disabled || isLoading}
      help={help}
    />
  )
}
